import { filterDividers, urls, formStringFieldPatterns, signStatuses, hubEventTypes, customEventTypes, fileIcons, allowedImageFileExtensions, formFieldTypes } from '../../constants.js';
import DocumentItem from '../documents/DocumentItem.js';
import DocumentLink from '../documents/DocumentLink.js';
import DocumentItemField from '../documents/DocumentItemField.js';
import { unknownErrorMessageDialog, messageDialog, errorMessageDialog, hideModalDialog, viewImage, viewFile } from '../ModalDialog.js';
import i18next from "../../i18n.js";
import { eventDispatcher } from '../../eventDispatcher.js';
import moment from 'moment';

export async function loadListData(listType, filter = null, skip = 0, take = 0, sortBy = '', isDesk = false, searchQuery = '') {
    const result = await fetch('api/List/Get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            skip: skip,
            listType: listType,
            take: take,
            filter: filter,
            sortBy: sortBy,
            isDesk: isDesk,
            searchQuery: searchQuery
        })
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
        })
        .catch((error) => {
            console.error(error);
        });
    return result;
}

export async function loadSubordinates() {
    const result = await fetch('api/Home/GetSubordinates')
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
        })
        .catch((error) => {
            console.error(error);
        });
    return result;
}

export function submitAction(taskId, documentId, action, comment, handleResult) {
    fetch('/api/Document/TaskAction', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: taskId,
            action: action,
            comment: comment,
            documentId: documentId
        })
    })
        .then(async (response) => {
            if (response.ok) {
                messageDialog(i18next.t('done'), i18next.t('document.actionDoneMessage'), () => { if (handleResult) handleResult(true); });
            }
            else if (response.status !== 500 && response.status !== 401) {
                unknownErrorMessageDialog();
                if (handleResult) handleResult(false);
            }
        })
        .catch(err => {
            console.error(err);
            unknownErrorMessageDialog();
            if (handleResult) handleResult(false);
        });
}

export function sendDocument(documentId, handleResult) {
    fetch(`/api/Document/Send/${documentId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(async (response) => {
            if (response.ok) {
                messageDialog(i18next.t('done'), i18next.t('document.sendingDoneMessage'), () => { if (handleResult) handleResult(true); });
            }
            else if (response.status !== 500 && response.status !== 401) {
                unknownErrorMessageDialog();
                if (handleResult) handleResult(false);
            }
        })
        .catch(err => {
            console.error(err);
            unknownErrorMessageDialog();
            if (handleResult) handleResult(false);
        });
}

export function renderDocumentItem(document, type, fieldSettings) {
    return <DocumentItem key={document.id} doc={document} type={type} fieldSettings={fieldSettings} />
}

export function renderDocumentLink(document, type) {
    return <DocumentLink key={document.id} doc={document} type={type} />
}

export function getArrayIds(columns) {
    let result = [];
    if (columns) {
        for (var i = 0; i < columns.length; i++)
            result.push(columns[i].id);
    }
    return result;
}
export function getFilterString(filterValues) {
    let filter = '';
    let addedCount = 0;
    let keys = filterValues ? Object.keys(filterValues) : [];
    for (var i = 0; i < keys.length; i++) {
        let values = filterValues[keys[i]];
        if (values.length > 0) {
            let needAdd = false;
            let addedPart = '';
            if (addedCount > 0)
                addedPart += filterDividers.FilterPartsDivider;
            addedPart += keys[i] + filterDividers.FilterNameValueDivider;
            for (var j = 0; j < values.length; j++) {
                if (values[j]) {
                    if (j > 0)
                        addedPart += filterDividers.FilterValuesDivider;
                    addedPart += encodeURIComponent(values[j]);
                    needAdd = true;
                }
            }
            if (needAdd) {
                addedCount++;
                filter += addedPart;
            }
        }
    }
    return filter;
}
export function parseFilterString(filter) {
    let filterValues = {};
    if (!filter) return filterValues;
    filter = decodeURIComponent(filter);
    let parts = filter.split(filterDividers.FilterPartsDivider);
    for (var i = 0; i < parts.length; i++) {
        let parts2 = parts[i].split(filterDividers.FilterNameValueDivider);
        if (parts2.length > 1 && parts2[0] && parts2[1]) {
            let key = parts2[0];
            let value = parts2[1];
            var valueParts = value.split(filterDividers.FilterValuesDivider);
            filterValues[key] = valueParts;
        }
    }
    return filterValues;
}
export function sortArray(items, fildName, isAsk = true) {
    items.sort(function (a, b) {
        var index1 = a[fildName];
        var index2 = b[fildName];
        if (index1 === null || index1 === undefined)
            index1 = 0;
        if (index2 === null || index2 === undefined)
            index2 = 0;
        let result = 0;
        if (index1 < index2) result = -1;
        if (index1 > index2) result = 1;
        if (!isAsk)
            result *= -1;
        return result;
    });
}
export function ExportToCSV(columns, items, fileName = "") {
    var csvContent = "Номер";
    if (columns && columns.length > 0) {
        for (var column of columns) {
            if (!(column.hidden === true))
                csvContent += ';"' + column.headerName.replaceAll('"', '""') + '"';
        }
    }
    csvContent += "\r\n";
    let index = 1;
    if (items && items.length > 0) {
        for (var item of items) {
            csvContent += index;
            for (var column of columns) {
                try {
                    if (!(column.hidden === true)) {
                        csvContent += ';"' + item.columns[column.name].replaceAll('"', '""') + '"';;
                    }
                }
                catch { csvContent += ";"; }
            }
            csvContent += "\r\n";
            index++;
        }
    }
    if (!fileName) fileName = "report.csv";
    if (!fileName.endsWith(".csv")) fileName += ".csv";
    var encodedUri = encodeURI(csvContent).replaceAll('#', '%23');
    if (window.navigator.msSaveBlob) { // IE
        csvContent = '\ufeff' + csvContent;
        var blob = new Blob([csvContent], { type: "data:text/csv;charset=utf-8,\uFEFF" });
        window.navigator.msSaveOrOpenBlob(blob, "report.csv");
    }
    else if (window.saveAs) {
        var blob = new Blob([csvContent], { type: "data:text/csv;charset=utf-8,\uFEFF" });
        window.saveAs(blob, "report.csv");
    }
    else {
        var link = document.createElement("a");
        link.setAttribute("href", "data:text/csv;charset=utf-8,\uFEFF" + encodedUri);
        link.setAttribute("download", fileName);
        link.dispatchEvent(new MouseEvent('click'));
    }
}
export const transliterationOfFirstLettersTable = {
    'Є': 'Ye', 'є': 'ye', 'Ї': 'Yi', 'ї': 'yi', 'Й': 'Y', 'й': 'y', 'Ю': 'Yu', 'ю': 'yu', 'Я': 'Ya', 'я': 'ya'
}
export const transliterationTable = {
    'А': 'A', 'а': 'a', 'Б': 'B', 'б': 'b', 'В': 'V', 'в': 'v', 'Г': 'H', 'г': 'h', 'Ґ': 'G', 'ґ': 'g', 'Д': 'D', 'д': 'd', 'Е': 'E', 'е': 'e', 'Є': 'Ie', 'є': 'ie', 'Ж': 'Zh', 'ж': 'zh',
    'З': 'Z', 'з': 'z', 'И': 'Y', 'и': 'y', 'І': 'I', 'і': 'i', 'Ї': 'I', 'ї': 'i', 'Й': 'I', 'й': 'i', 'К': 'K', 'к': 'k', 'Л': 'L', 'л': 'l', 'М': 'M', 'м': 'm', 'Н': 'N', 'н': 'n', 'О': 'O', 'о': 'o',
    'П': 'P', 'п': 'p', 'Р': 'R', 'р': 'r', 'С': 'S', 'с': 's', 'Т': 'T', 'т': 't', 'У': 'U', 'у': 'u', 'Ф': 'F', 'ф': 'f', 'Х': 'Kh', 'х': 'kh', 'Ц': 'Ts', 'ц': 'ts', 'Ч': 'Ch', 'ч': 'ch', 'Ш': 'Sh', 'ш': 'sh',
    'Щ': 'Shch', 'щ': 'shch', 'Ю': 'Iu', 'ю': 'iu', 'Я': 'Ia', 'я': 'ia', 'Ь': '', 'ь': ''
}
export function transliterateString(str, ownName = true) {
    if (!str)
        return str;
    var re = /^.{0,}[а-яa-z].{0,}$/;
    var isUpper = !re.test(str);
    re = /([A-Za-zА-Яа-я]{1,})['`]{1,}([A-Za-zА-Яа-я]{1,})/g;
    str = str.replace(re, '$1$2');
    if (!ownName) {
        str = str.replaceAll('зг', 'zgh');
        str = str.replaceAll('Зг', 'Zgh');
        str = str.replaceAll('зГ', 'zGH');
        str = str.replaceAll('ЗГ', 'ZGH');
    }
    for (var key in transliterationOfFirstLettersTable) {
        re = new RegExp(`(\b)${key}`, 'g');
        str = str.replace(re, '$1' + transliterationOfFirstLettersTable[key]);
    }
    for (var key in transliterationTable) {
        str = str.replaceAll(key, transliterationTable[key]);
    }
    if (isUpper) str = str.toUpperCase();
    return str;
}
export function urltoFile(url, filename, mimeType) {
    return (fetch(url)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
}
export function getFormHeaderMessage() {
    return new Promise((resolve) => {
        resolve('Хочеш у відпустку? Тобі сюди! 😊');
    });
}
export function setUrlParam(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);
    var kvp = document.location.search.substr(1).split('&');
    let i = 0;
    for (; i < kvp.length; i++) {
        if (kvp[i].startsWith(key + '=')) {
            let pair = kvp[i].split('=');
            pair[1] = value;
            kvp[i] = pair.join('=');
            break;
        }
    }
    if (i >= kvp.length) {
        kvp[kvp.length] = [key, value].join('=');
    }
    let params = kvp.join('&');
    if (params.length > 0) {
        if (params[0] === "&") {
            params = params.replace("&", "?");
        }
        else {
            params = "?" + params;
        }
    }
}
export function getUrlParam(param) {
    let result = '';
    let parts = window.location.search.substring(1).split('&');
    if (parts.length > 0) {
        for (var i in parts) {
            var parts2 = parts[i].split('=');
            if (parts2.length > 1 && parts2[0].toLocaleLowerCase() === param.toLocaleLowerCase()) {
                result = parts2[1].toLocaleLowerCase();
                break;
            }
        }
    }
    return result;
}
export function getCurrentUrlPath() {
    let curUrl = window.location.pathname;
    if (curUrl && curUrl.length > 1 && curUrl[curUrl.length - 1] === '/')
        curUrl = curUrl.substring(0, curUrl.length - 1);
    return curUrl;
}
export function getWordWithCorrectEnding(number, word) {
    number = parseInt(number);
    switch (word) {
        case 'спроба':
            {
                let lastTwoNumbers = Math.round(((number / 100) % 1) * 100);
                if (number % 0 === 0 || number % 5 === 0 || number % 6 === 0 || number % 7 === 0 || number % 8 === 0 || number % 9 === 0 || (lastTwoNumbers >= 11 && lastTwoNumbers <= 19))
                    return 'спроб';
                if (number % 2 === 0 || number % 3 === 0 || number % 4 === 0)
                    return 'спроби';
                if (number % 1)
                    return 'спроба';
            }
        case 'хвилина':
            {
                let str = number.toString();
                let lastNumber = parseInt(str[str.length - 1]);
                if (lastNumber === 1 && (number < 11 || number > 19))
                    return 'хвилину';
                if ((lastNumber === 2 || lastNumber === 3 || lastNumber === 4) && (number < 11 || number > 19))
                    return 'хвилини';
                return 'хвилин';
            }
        case 'година':
            {
                let str = number.toString();
                let lastNumber = parseInt(str[str.length - 1]);
                if (lastNumber === 1 && (number < 11 || number > 19))
                    return 'годину';
                if ((lastNumber === 2 || lastNumber === 3 || lastNumber === 4) && (number < 11 || number > 19))
                    return 'години';
                return 'годин';
            }
        case 'день':
            {
                let str = number.toString();
                let lastNumber = parseInt(str[str.length - 1]);
                if (lastNumber === 1 && (number < 11 || number > 19))
                    return 'день';
                if ((lastNumber === 2 || lastNumber === 3 || lastNumber === 4) && (number < 11 || number > 19))
                    return 'дні';
                return 'днів';
            }
        case 'ніч':
            {
                let str = number.toString();
                let lastNumber = parseInt(str[str.length - 1]);
                if (lastNumber === 1 && (number < 11 || number > 19))
                    return 'ніч';
                if ((lastNumber === 2 || lastNumber === 3 || lastNumber === 4) && (number < 11 || number > 19))
                    return 'ночі';
                return 'ночей';
            }
        case 'календарний день':
            {
                let str = number.toString();
                let lastNumber = parseInt(str[str.length - 1]);
                if (lastNumber === 1 && (number < 11 || number > 19))
                    return 'календарний день';
                if ((lastNumber === 2 || lastNumber === 3 || lastNumber === 4) && (number < 11 || number > 19))
                    return 'календарних дні';
                return 'календарних днів';
            }
            break;
    }
    return word;
}
export function base64toBlob(data, mimeType) {
    const prefix = `data:${mimeType};base64,`;
    if (data.startsWith(prefix)) {
        data = data.substr(prefix.length);
    }
    const bytes = atob(data);
    let length = bytes.length;
    let out = new Uint8Array(length);
    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: mimeType });
};
export async function logout() {
    if (document.location.pathname !== urls.loginPage) {
        await fetch('/api/Account/LogOut', { method: "POST" });
        document.location.replace(`${urls.loginPage}?return=${document.location.pathname}${document.location.search}`)
    }
};
export function changeInputValue(e) {
    let { name, type, value, checked } = e.target;
    if (e.target) {
        switch (e.target.getAttribute('pattern')) {
            case formStringFieldPatterns.integer:
                value = value.replace(/\D/g, "");
                break;
            default: break;
        }
    }
    this.setState({ [name]: type === "checkbox" ? checked : value });
}
export const uint8ToBase64 = (arr) => btoa(Array(arr.length).fill('').map((_, i) => String.fromCharCode(arr[i])).join(''));
export const objToLowercase = obj => Object.keys(obj).reduce((acc, key) => { acc[key.toLowerCase()] = obj[key]; return acc; }, {});
export function setOnPageCount(count) {
    localStorage.setItem('onPageCount', count);
}
export function getOnPageCount() {
    let count = parseInt(localStorage.getItem('onPageCount') ?? 10);
    if (count > 100)
        count = 100;
    return count;
}
export function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}
export function parseUtcDateString(date) {
    let result = '';
    try {
        if (date) {
            date = date.split('T')[0];
            let dateParts = date.split('-');
            if (dateParts.length === 3)
                result = date;
        }
    }
    catch (ex) {
        console.error('parseUtcDateString error');
        console.error(ex);
    }
    return result;
}
export function getLocalDateString(date) {
    try {
        return date.toLocaleDateString("uk-UA", { timeZone: 'Europe/Kiev' });
    }
    catch (ex) {
        console.error('getLocalDateString error');
        console.error(ex);
        return date.toLocaleDateString("uk-UA");
    }
}
export function getLocalTimeString(date) {
    try {
        return date.toLocaleTimeString("uk-UA", { timeZone: 'Europe/Kiev' });
    }
    catch (ex) {
        console.error('getLocalTimeString error');
        console.error(ex);
        return date.toLocaleTimeString("uk-UA");
    }
}
export function localDateToUTC(date) {
    return new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ));
}
export function capitalizeObjectKeys(obj) {
    Object.keys(obj).forEach(key => {
        if (key && key.length > 0) {
            let newKey = key[0].toUpperCase() + key.substring(1);
            if (obj.hasOwnProperty(key) && !obj.hasOwnProperty(newKey)) {
                obj[newKey] = obj[key];
                delete obj[key];
            }
        }
    });
    return obj;
}
export function deepObjectEqual(object1, object2) {
    if (!object1 && !object2)
        return true;
    if (!object1 || !object2)
        return false;

    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if (
            (areObjects && !deepObjectEqual(val1, val2)) ||
            (!areObjects && val1 !== val2)
        ) {
            return false;
        }
    }

    return true;
}
export function isObject(object) {
    return object != null && typeof object === 'object';
}
// Settings keys come from the form configuration as they are written there, so they are matched
// without case sensitivity to stay independent of the serializer naming policy.
export function getFieldSetting(settings, key) {
    const foundKey = Object.keys(settings ?? {}).find(item => item.toLowerCase() === key.toLowerCase());
    return foundKey ? settings[foundKey] : null;
}
export function getCurrentCompany() {
    let user = JSON.parse(localStorage?.getItem('user'));
    return user?.companies[0]
}
export function onKeyDown(e) {
    if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
    }
}

export function isMobile() {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    return isMobile || (isTouch && isSmallScreen);
}

// Кеш для аватарок: ключ = "login:avatarId", значення = data URL або Promise
const avatarCache = new Map();

// Конвертує blob в base64 data URL
function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

export async function loadAvatar(login, avatarId) {
    if (!login || !avatarId) {
        return null;
    }

    const cacheKey = `${login}:${avatarId}`;

    // Якщо вже є в кеші (data URL або Promise) - повернути
    if (avatarCache.has(cacheKey)) {
        return avatarCache.get(cacheKey);
    }

    // Створюємо Promise і зберігаємо його одразу (для дедуплікації паралельних запитів)
    const loadPromise = fetch(`/api/Account/GetUserImage?userName=${login}&id=${avatarId}`)
        .then((response) => {
            if (response.ok) {
                return response.blob();
            }
            return null;
        })
        .then(async (blob) => {
            if (blob) {
                // Конвертуємо в base64 data URL - ніколи не стає невалідним
                const dataUrl = await blobToDataUrl(blob);
                avatarCache.set(cacheKey, dataUrl);
                return dataUrl;
            }
            avatarCache.delete(cacheKey);
            return null;
        })
        .catch(() => {
            avatarCache.delete(cacheKey);
            return null;
        });

    avatarCache.set(cacheKey, loadPromise);
    return loadPromise;
}
// navigator.clipboard доступний лише в захищеному контексті (https або localhost),
// тому для звичайного http лишається запасний шлях через приховане поле
export function copyTextToClipboard(text) {
    if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text).catch(() => copyTextWithTextArea(text));
    }
    copyTextWithTextArea(text);
    return Promise.resolve();
}
function copyTextWithTextArea(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
}
export async function getDodumentFiles(url, loadInfos) {
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loadInfos)
    });
    if (response.ok) {
        let data = await response.json();
        data.forEach((item) => {
            if (item.file.mimeType === 'application/pdf' && !item.file.fileName.endsWith('.pdf')) {
                item.file.fileName += '.pdf';
            }
            item.file.content = window.URL.createObjectURL(base64toBlob(item.file.content, item.file.mimeType));
        });
        return data;
    }
}
export function viewDocumentFile(fileNodeRef) {
    getDodumentFiles('/api/file/GetSignedFiles', [{
        nodeRef: fileNodeRef,
        loadAsPdf: true
    }]).then(result => {
        if (result) {
            if (result[0].file.mimeType == 'application/pdf') {
                viewFile(result[0].file.content, result[0].file.fileName);
            }
            else if (acceptImageFileString.split(',').includes(result[0].file.mimeType)) {
                viewImage(result[0].file.content);
            }
            else {
                messageDialog('', i18next.t("document.notViewedMessage"));
            }
        }
        else {
            unknownErrorMessageDialog();
        }
    });
}
export async function getSignStatus(docIds) {
    let responseResult = await fetch('Home/GetSignalRMessages')
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
        });
    if (responseResult) {
        if (responseResult.messageData && responseResult.messageData.length > 0) {
            let documenMessages = responseResult.messageData.filter(m => docIds.includes(m.message.messageData));
            for (let i = 0; i < documenMessages.length; i++) {
                switch (documenMessages[i].eventType) {
                    case hubEventTypes.documentSigned:
                        return signStatuses.signed;
                        break;
                    case hubEventTypes.documentSignedError:
                        return signStatuses.error;
                        break;
                    case hubEventTypes.documentSignCanceled:
                        return signStatuses.cancaled;
                        break;
                }
            }
        }
    }
    return signStatuses.notSigned;
}
export function showSignStatusMessage(status, onClose) {
    switch (status) {
        case signStatuses.signed:
            messageDialog(i18next.t('done'), i18next.t('document.successSignedMessage'), () => {
                if (onClose) onClose();
            });
            break;
        case signStatuses.error:
            errorMessageDialog(i18next.t('document.errorSignedMessage'), () => {
                if (onClose) onClose();
            });
            break;
        case signStatuses.cancaled:
            errorMessageDialog(i18next.t('document.documentSignCanceled'), () => {
                if (onClose) onClose();
            });
            break;
    }
}
export function subscribeToSignEvents(documentsInSigningRef) {
    let signedEventId, signedErrorEventId, canceledEventId, returnToPageId, signingStartedId;

    const onSignEvent = (docId, signedStatus) => {
        if (documentsInSigningRef.current.includes(docId)) {
            documentsInSigningRef.current = documentsInSigningRef.current.filter(val => val !== docId);
            hideModalDialog('modalDialog');
            showSignStatusMessage(signedStatus, () => window.location.reload());
        }
    }

    signedEventId = eventDispatcher.subscrubeToEvent(hubEventTypes.documentSigned, (params) => onSignEvent(params, signStatuses.signed));
    signedErrorEventId = eventDispatcher.subscrubeToEvent(hubEventTypes.documentSignedError, (params) => onSignEvent(params, signStatuses.error));
    canceledEventId = eventDispatcher.subscrubeToEvent(hubEventTypes.documentSignCanceled, (params) => onSignEvent(params, signStatuses.cancaled));

    returnToPageId = eventDispatcher.subscrubeToEvent(customEventTypes.onReturnToPage, async () => {
        if (documentsInSigningRef.current.length > 0) {
            getSignStatus(documentsInSigningRef.current).then(status => {
                if (documentsInSigningRef.current.length > 0 && status !== signStatuses.notSigned) {
                    hideModalDialog('modalDialog');
                    showSignStatusMessage(status, () => {
                        window.location.reload();
                    });
                }
            });
        }
    });
    signingStartedId = eventDispatcher.subscrubeToEvent(customEventTypes.onSignStarted, (params) => {
        documentsInSigningRef.current.push(params);
    });

    return () => {
        eventDispatcher.unsubscrubeFromEvent(signedEventId);
        eventDispatcher.unsubscrubeFromEvent(signedErrorEventId);
        eventDispatcher.unsubscrubeFromEvent(canceledEventId);
        eventDispatcher.unsubscrubeFromEvent(returnToPageId);
        eventDispatcher.unsubscrubeFromEvent(signingStartedId);
    }
}

export async function showPermissionRequest(alwaysShowRequest = false, onSuccessCallBack = null, onFailCallBack = null) {

    const saveSubscription = async (pushSubscription) => {
        const pushJson = pushSubscription.toJSON();
        const saveResponse = await fetch('/api/home/SavePushSubscription', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                endpoint: pushJson.endpoint,
                auth: pushJson.keys.auth,
                p256dh: pushJson.keys.p256dh
            })
        });
        if (!saveResponse.ok) {
            console.error('SavePushSubscription error');
            console.error('Status Code: ' + response.status);
        }
        else {
            if (onSuccessCallBack) onSuccessCallBack();
        }
    }

    if (navigator.serviceWorker && window.PushManager) {
        if (Notification.permission === "default" || alwaysShowRequest) {
            Notification.requestPermission((status) => {
                if (status === "granted") {
                    fetch('/api/home/GetPushNotificationKey').then(async response => {
                        if (response.ok) {
                            const key = await response.text();
                            if (key) {
                                let currentRegistration = await navigator.serviceWorker.getRegistration('/portal-service-worker.js');
                                if (currentRegistration) {
                                    await currentRegistration.unregister();
                                }
                                navigator.serviceWorker.register('/portal-service-worker.js')
                                    .then(registration => {
                                        const subscribe = () => {
                                            const subscribeOptions = {
                                                userVisibleOnly: true,
                                                applicationServerKey: key
                                            };
                                            registration.pushManager.getSubscription()
                                                .then(pushSubscription => {
                                                    if (pushSubscription == null) {
                                                        registration.pushManager.subscribe(subscribeOptions)
                                                            .then(pushSubscription => saveSubscription(pushSubscription));
                                                    }
                                                    else
                                                        saveSubscription(pushSubscription);
                                                });
                                        }

                                        let serviceWorker;
                                        if (registration.installing) {
                                            serviceWorker = registration.installing;
                                        } else if (registration.waiting) {
                                            serviceWorker = registration.waiting;
                                        } else if (registration.active) {
                                            serviceWorker = registration.active;
                                        }

                                        if (serviceWorker) {
                                            if (serviceWorker.state == 'activated') {
                                                subscribe();
                                            }
                                            else {
                                                serviceWorker.addEventListener('statechange', e => {
                                                    if (e.target.state == 'activated') {
                                                        subscribe();
                                                    }
                                                });
                                            }
                                        }
                                    })
                            }
                        }
                    });
                }
                else {
                    if (onFailCallBack) onFailCallBack();
                }
            });
        }
        else {
            if (onSuccessCallBack && Notification.permission === "granted") {
                onSuccessCallBack();
            }
        }
    }
}

export function getPassedText(daysDiff) {
    if (daysDiff.diffDays > 0) {
        return `${daysDiff.diffDays} ${getWordWithCorrectEnding(daysDiff.diffDays, 'день')} тому`;
    }
    if (daysDiff.diffHours > 0) {
        return `${daysDiff.diffHours} ${getWordWithCorrectEnding(daysDiff.diffHours, 'година')} тому`;
    }
    if (daysDiff.diffMinutes > 0) {
        return `${daysDiff.diffMinutes} ${getWordWithCorrectEnding(daysDiff.diffMinutes, 'хвилина')} тому`;
    }

    return 'щойно';
}

export function getDaysDiff(start, end) {
    const diffMs = end - start;

    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return {
        diffSeconds,
        diffMinutes,
        diffHours,
        diffDays
    }
}

export function getFileIconUrl(fileName) {
    if (fileName) {
        const parts = fileName.toLowerCase().split('.');
        const extension = parts[parts.length - 1];
        if (extension === 'pdf') return fileIcons.pdf;
        if (extension === 'doc' || extension === 'docx') return fileIcons.doc;
        if (extension === 'xls' || extension === 'xlsx') return fileIcons.excel;
        if (allowedImageFileExtensions.includes(extension)) return fileIcons.image;
    }
    return fileIcons.default;
}

export function downloadTemplate(fileName) {
    fetch(`api/home/GetTemplateFileContent`)
        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            let anchor = document.createElement("a");
            anchor.href = objectUrl;
            anchor.download = fileName ?? "Шаблон.docx";
            anchor.click();
            window.URL.revokeObjectURL(objectUrl);
        });
}

export function getSubformFieldPreview(field, properties) {
    let result = '';
    const prefix = field.previewPrefix ?? '';
    const postfix = field.previewPostfix ?? '';
    switch (field.type) {
        case formFieldTypes.select:
            if (properties[field.name]) {
                const selectedItem = field.values.data.find(item => item.value === properties[field.name]);
                if (selectedItem?.label) {
                    result = `${prefix}${selectedItem.label}${postfix}`;
                }
            }
            break;
        case formFieldTypes.bool:
            result = `${prefix}${properties[field.name] ? i18next.t('other.yes') : i18next.t('other.no')}${postfix}`;
            break;
        case formFieldTypes.warningcheckbox:
            if (properties[field.name] != null && properties[field.name] != undefined) {
                result = `${prefix}${properties[field.name] ? i18next.t('other.yes') : i18next.t('other.no')}${postfix}`;
            }
            break;
        case formFieldTypes.datetime:
            if (properties[field.name]) {
                result = `${prefix}${getLocalDateString(new Date(properties[field.name]))}${postfix}`;
            }
            break;
        default:
            if (properties[field.name]) {
                result = `${prefix}${properties[field.name]}${postfix}`;
            }
            break;
    }
    return result;
}
function getSubformHeaderFieldValue(field, value) {
    switch (field.type) {
        case formFieldTypes.select:
            const valueItem = field.values?.data?.find(it => it.value === value);
            if (valueItem) return valueItem.label;
            return value;
        case formFieldTypes.datetime:
            const date = moment(value, 'YYYY-MM-DD');
            return date.format("DD.MM.YYYY");
        default:
            return value;
    }
}
// group and formgroup only wrap fields visually, so header and preview settings are read from the nested fields too
function flattenFormFields(fields) {
    return (fields ?? []).flatMap(field => field.type === formFieldTypes.group || field.type === formFieldTypes.formGroup
        ? flattenFormFields(field.fields)
        : field);
}
export function getSubformHeaderInfo(fields, properties) {
    const headerFields = flattenFormFields(fields).filter(f => f.showInHeader && f.visible);
    headerFields.sort((a, b) => a.headerSortIndex - b.headerSortIndex);
    return headerFields.map(f => <DocumentItemField
        key={f.name}
        field={{
            name: f.name,
            value: getSubformHeaderFieldValue(f, properties[f.name])
        }}
        settings={f} />);
}

export function getSubformHeaderPreview(fields, properties) {
    const previewParts = [];
    const allFields = flattenFormFields(fields);
    const previewFields = allFields.filter(f => f.showInPreview && f.visible);
    previewFields.sort((a, b) => a.previewSortIndex - b.previewSortIndex);
    previewFields.forEach(field => {
        let part = getSubformFieldPreview(field, properties);
        if (field.nextPreviewField) {
            const nextField = allFields.find(f => f.name === field.nextPreviewField);
            if (nextField) {
                let part2 = getSubformFieldPreview(nextField, properties);
                const separator = field.previewSeparator ?? '';
                if (part2) {
                    part += `${separator}${part2}`;
                }
            }
        }
        if (part) {
            previewParts.push(part);
        }
    });

    if (previewParts.length > 0) {
        return previewParts.join(', ');
    }
    else {
        return i18next.t('other.fieldsNotFilledIn');
    }
}